import React, { Fragment, useState, useEffect } from 'react';
import { useQuery, useMutation } from '@apollo/client';
import { GET_LIBRO, UPDATE_LIBRO } from '../../graphql/actions/libro';
import axios from 'axios';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
// @material-ui/icons
// core components
import GridContainer from '../UI/Grid/GridContainer';
import GridItem from '../UI/Grid/GridItem';
import CustomInput from '../UI/CustomInput/CustomInput';
import CustomFileInput from '../UI/CustomFileInput/CustomFileInput';
import Badge from '../UI/Badge/Badge';
import Button from '../UI/CustomButtons/Button';
import Spinner from '../UI/Spinner/Spinner';
import Notification from '../Notification/Notification';
// Validations
import { isEmpty, countWords } from '../../util/validators';

import sectionAddStyle from '../../assets/jss/coscef/views/articuloSections/sectionAddStyle';

const url =
  process.env.NODE_ENV === 'development'
    ? 'http://100.100.100.248:4000/'
    : 'https://api.coscef.nat.cu/';

const useStyles = makeStyles(sectionAddStyle);

const LibroEdt = (props) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  }, []);
  const classes = useStyles();
  const [formTitulo, setFormTitulo] = useState('');
  const [formAutor, setFormAutor] = useState('');
  const [formResumen, setFormResumen] = useState('');
  const [formCaratula, setFormCaratula] = useState('');
  const [formDatos, setFormDatos] = useState('');
  const [singleImg, setSingleImg] = useState('');
  const [singleFile, setSingleFile] = useState('');
  const [fileImgProgress, setFileImgProgress] = useState(0);
  const [singleFileProgress, setSingleFileProgress] = useState(0);
  const [imgStatus, setImgStatus] = useState('Esperando fichero');
  const [fileStatus, setFileStatus] = useState('Esperando fichero');
  const [imgStatusColor, setImgStatusColor] = useState('gray');
  const [fileStatusColor, setFileStatusColor] = useState('gray');
  const [edtForm, setEdtForm] = useState({
    titulo: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    autor: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
    resumen: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty, countWords({ min: 30, max: 38 })],
    },
    estado: {
      value: '',
      valid: true,
      touched: false,
      validators: [isEmpty],
    },
    caratula: {
      value: '',
      valid: true,
      touched: false,
      validators: [isEmpty],
    },
    datos: {
      value: '',
      valid: false,
      touched: false,
      validators: [isEmpty],
    },
  });
  const [formIsValid, setFormIsValid] = useState(false);
  const [caratulaIsValid, setCaratulaIsValid] = useState(false);
  const [formIsImg, setFormIsImg] = useState(false);
  const [formIsFile, setFormIsFile] = useState(false);

  const inputChangedHandler = (value, input) => {
    let isValid = true;

    for (let validator of edtForm[input].validators) {
      isValid = isValid && validator(value);

      if (input === 'titulo') {
        if (isValid) setFormTitulo('success');
        else setFormTitulo('error');
      }
      if (input === 'autor') {
        if (isValid) setFormAutor('success');
        else setFormAutor('error');
      }
      if (input === 'resumen') {
        if (isValid) setFormResumen('success');
        else setFormResumen('error');
      }
      if (input === 'caratula') {
        if (isValid) setFormCaratula('success');
        else setFormCaratula('error');
      }
      if (input === 'datos') {
        if (isValid) setFormDatos('success');
        else setFormDatos('error');
      }
    }

    const updatedForm = {
      ...edtForm,
      [input]: {
        ...edtForm[input],
        valid: isValid,
        value: value,
      },
    };

    let count = 6;
    let formIsValid = true;
    for (const inputName in updatedForm) {
      //formIsValid = formIsValid && updatedForm[inputName].valid;
      if (updatedForm[inputName].valid) count -= 1;
    }

    //console.log(count);
    if (count <= 5) formIsValid = true;
    else formIsValid = false;

    setEdtForm(updatedForm);
    setFormIsValid(formIsValid);
    if (input === 'estado' && value === 'Publicado') setCaratulaIsValid(true);
    else if (input === 'estado' && value === 'No publicado')
      setCaratulaIsValid(false);
  };

  const onImgInputChange = (inputFiles, inputFilesNames) => {
    if (inputFiles[0]) {
      setSingleImg(inputFiles[0]);
      setFormIsImg(true);
    } else {
      setSingleImg('');
      setFormIsImg(false);
    }
  };

  const onFileInputChange = (inputFiles, inputFilesNames) => {
    if (inputFiles[0]) {
      setSingleFile(inputFiles[0]);
      setFormIsFile(true);
    } else {
      setSingleFile('');
      setFormIsFile(false);
    }
  };

  const onImgUploadHandler = async () => {
    //console.log(singleFile);
    if (singleImg) {
      try {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            const percentage = Math.floor(
              ((loaded / 1000) * 100) / (total / 1000)
            );
            setFileImgProgress(percentage);
          },
        };
        const formData = new FormData();
        formData.append('img', singleImg);

        const response = await axios.post(
          url + 'api/file/img',
          formData,
          config
        );

        if (response.data) {
          //console.log(response.data);
          setImgStatus(response.data.message);
          setImgStatusColor('success');
          inputChangedHandler(response.data.url, 'caratula');
        }
      } catch (error) {
        //console.log(error.response.data);
        setImgStatus(error.response.data.message);
        setImgStatusColor('danger');
      }
    }
  };

  const onFileUploadHandler = async () => {
    //console.log(singleFile);
    if (singleFile) {
      try {
        const config = {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          onUploadProgress: (progressEvent) => {
            const { loaded, total } = progressEvent;
            const percentage = Math.floor(
              ((loaded / 1000) * 100) / (total / 1000)
            );
            setSingleFileProgress(percentage);
          },
        };
        const formData = new FormData();
        formData.append('arch', singleFile);

        const response = await axios.post(
          url + 'api/file/arch',
          formData,
          config
        );

        if (response.data) {
          //console.log(response.data);
          setFileStatus(response.data.message);
          setFileStatusColor('success');
          inputChangedHandler(response.data.url, 'datos');
        }
      } catch (error) {
        //console.log(error.response.data);
        setFileStatus(error.response.data.message);
        setFileStatusColor('danger');
      }
    }
  };

  const redirectToLibros = (data) => {
    //console.log(data);
    if (data.updateLibro) props.history.push('/libros');
    else console.log('Error editando libro');
  };

  const {
    loading: loadingLibro,
    error: errorLibro,
    data: dataLibro,
  } = useQuery(GET_LIBRO, {
    variables: {
      id: props.match.params.id,
    },
    skip: !props.match.params.id,
    errorPolicy: 'all',
  });

  const [
    editLibro,
    { loading: loadingEdtLibro, error: errorEdtLibro, data: dataEdtLibro },
  ] = useMutation(UPDATE_LIBRO, {
    errorPolicy: 'all',
    //update: updateCacheEdt,
    onCompleted: (data) => redirectToLibros(data),
  });

  const editarHandler = (event) => {
    event.preventDefault();

    const libroData = {};
    for (let i in edtForm) {
      if (edtForm[i].value === '') continue;
      else libroData[i] = edtForm[i].value;
    }

    //console.log(libroData);

    editLibro({
      variables: {
        input: {
          id: props.match.params.id,
          titulo: libroData.titulo,
          autor: libroData.autor,
          resumen: libroData.resumen,
          estado: libroData.estado,
          caratula: libroData.caratula,
          datos: libroData.datos,
        },
      },
    });
  };

  let seccionTitulo = null;
  let seccionButton = null;
  let seccionFormulario = null;
  let showNotification = null;

  if (loadingLibro) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />;
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = null;
    seccionFormulario = null;
  }
  if (loadingEdtLibro) seccionButton = <Spinner color='gray' />;

  if (errorLibro) {
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Error buscando el libro.</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = null;
    seccionFormulario = null;

    showNotification = errorLibro.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorLibro ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }
  if (errorEdtLibro) {
    showNotification = errorEdtLibro.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorEdtLibro ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataLibro && dataLibro.getLibro) {
    const { getLibro } = dataLibro;
    //console.log(getLibro);
    seccionTitulo = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title}>Editar Libro</h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    seccionButton = (
      <GridContainer>
        <GridItem
          md={4}
          sm={4}
          className={classNames(
            classes.mrAuto,
            classes.mlAuto,
            classes.textCenter
          )}
        >
          <Button type='submit' color='dark' round disabled={!formIsValid}>
            Editar Libro
          </Button>
        </GridItem>
      </GridContainer>
    );

    seccionFormulario = (
      <div id='formularioEdt'>
        <GridContainer>
          <GridItem
            md={8}
            sm={8}
            className={classNames(classes.mrAuto, classes.mlAuto)}
          >
            <form onSubmit={editarHandler}>
              <GridContainer>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Título (*)'
                    success={formTitulo === 'success'}
                    error={formTitulo === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'titulo');
                      },
                      placeholder: getLibro.titulo,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Autor (*)'
                    success={formAutor === 'success'}
                    error={formAutor === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'autor');
                      },
                      placeholder: getLibro.autor,
                    }}
                  />
                </GridItem>
                <GridItem md={12} sm={12}>
                  <CustomInput
                    labelText='Resumen (De 30 a 38 palabras)'
                    success={formResumen === 'success'}
                    error={formResumen === 'error'}
                    formControlProps={{
                      fullWidth: true,
                    }}
                    inputProps={{
                      onChange: (event) => {
                        inputChangedHandler(event.target.value, 'resumen');
                      },
                      multiline: true,
                      rows: 6,
                      placeholder: getLibro.resumen,
                    }}
                  />
                </GridItem>
                <GridItem md={3} sm={3}>
                  <div className={classes.control1}>
                    <FormControl
                      fullWidth
                      className={classes.selectFormControl}
                    >
                      <InputLabel
                        htmlFor='estado-select'
                        className={classes.selectLabel}
                      >
                        Estado del Libro
                      </InputLabel>
                      <Select
                        MenuProps={{
                          className: classes.selectMenu,
                        }}
                        classes={{
                          select: classes.select,
                        }}
                        //value={simpleSelect}
                        onChange={(event) => {
                          inputChangedHandler(event.target.value, 'estado');
                        }}
                        inputProps={{
                          name: 'estadoSelect',
                          id: 'estado-select',
                        }}
                      >
                        <MenuItem
                          disabled
                          classes={{
                            root: classes.selectMenuItem,
                          }}
                        >
                          {getLibro.estado}
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value='No publicado'
                        >
                          No publicado
                        </MenuItem>
                        <MenuItem
                          classes={{
                            root: classes.selectMenuItem,
                            selected: classes.selectMenuItemSelected,
                          }}
                          value='Publicado'
                        >
                          Publicado
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </GridItem>
                {caratulaIsValid || getLibro.estado === 'Publicado' ? (
                  <GridItem md={9} sm={9}>
                    <div className={classes.control}>
                      <CustomFileInput
                        id={'img'}
                        onChange={onImgInputChange}
                        success={formCaratula === 'success'}
                        error={formCaratula === 'error'}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          placeholder: getLibro.caratula,
                        }}
                      />
                      <div>
                        <div className={classes.circleBar}>
                          <CircularProgressbar
                            value={fileImgProgress}
                            text={`${fileImgProgress}%`}
                            style={buildStyles({
                              rotation: 0.25,
                              strokeLinecap: 'butt',
                              textSize: '12px',
                              pathTransitionDuration: 0.5,
                              pathColor: `rgb(62, 152, 199, ${
                                fileImgProgress / 100
                              })`,
                              textColor: '#4caf50',
                              trailColor: '#d6d6d6',
                              backgroundColor: '#dff0d8',
                            })}
                          />
                        </div>
                        <Badge
                          className={classes.marginLeft20}
                          color={imgStatusColor}
                        >
                          {imgStatus}
                        </Badge>
                        <Button
                          color='dark'
                          round
                          className={classes.floatRight}
                          disabled={!formIsImg}
                          onClick={onImgUploadHandler}
                        >
                          Subir Caratula
                        </Button>
                      </div>
                    </div>
                  </GridItem>
                ) : null}
                <GridItem md={12} sm={12}>
                  <div className={classes.control}>
                    <CustomFileInput
                      id={'arch'}
                      onChange={onFileInputChange}
                      success={formDatos === 'success'}
                      error={formDatos === 'error'}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        placeholder: getLibro.datos,
                      }}
                    />
                    <div>
                      <div className={classes.circleBar}>
                        <CircularProgressbar
                          value={singleFileProgress}
                          text={`${singleFileProgress}%`}
                          style={buildStyles({
                            rotation: 0.25,
                            strokeLinecap: 'butt',
                            textSize: '12px',
                            pathTransitionDuration: 0.5,
                            pathColor: `rgb(62, 152, 199, ${
                              singleFileProgress / 100
                            })`,
                            textColor: '#4caf50',
                            trailColor: '#d6d6d6',
                            backgroundColor: '#dff0d8',
                          })}
                        />
                      </div>
                      <Badge
                        className={classes.marginLeft20}
                        color={fileStatusColor}
                      >
                        {fileStatus}
                      </Badge>
                      <Button
                        color='dark'
                        round
                        className={classes.floatRight}
                        disabled={!formIsFile}
                        onClick={onFileUploadHandler}
                      >
                        Subir Datos
                      </Button>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              {seccionButton}
            </form>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
  if (dataEdtLibro && dataEdtLibro.updateLibro) {
    const { updateLibro } = dataEdtLibro;
    if (updateLibro.success && updateLibro.code === '201') {
      showNotification = (
        <Notification
          key={updateLibro.code}
          mostrar={updateLibro.success ? true : false}
          msg={updateLibro.message}
          stt={updateLibro.success}
        />
      );
    }
  }

  return (
    <Fragment>
      <div
        className={classNames(classes.main, classes.mainRaised)}
        id='main-panel'
      >
        <div className={classes.sections}>
          <div className={classes.sectionWhite}>
            <div>
              <div className={classes.container}>
                {seccionTitulo}
                <div className={classes.marginTop35}>{seccionFormulario}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.sectionfinal}>{showNotification}</div>
    </Fragment>
  );
};

export default withRouter(LibroEdt);
